export const CREATE_INVOICE = 'createInvoice';
export const CHANGE_INVOICE_UNITS_REGISTER = 'changeInvoiceUnitsRegister';
export const ADD_INVOICE_UNIT = 'addInvoiceUnit';
export const SELECT_MEMBER_INVOICE = 'selectMemberInvoice';
export const EXECUTE_MEMBERSHIP_ACTIONS = 'executeMembershipActions';
export const ADD_TOP_UP_BALANCE = 'addTopUpBalance';
export const EXECUTE_MEMBER_PORTAL_ACTIONS = 'executeMemberPortalActions';
